import { IChartLayerProps, ILayerBehavior } from '@/version-types';
import { getFontsByPosition } from '../utils/core';

type Behaviors = Pick<ILayerBehavior, 'getTextInfo' | 'isTextEditable'>;

type FontItem = { fontFamily: string; text: string };

export const collectChartLayerFonts = (layerData: IChartLayerProps): FontItem[] => {
    const allFonts = getFontsByPosition(layerData, 'all');

    const resultFontList = allFonts
        // 重复的fontFamily进行合并
        .reduce<FontItem[]>((fontList, font) => {
            const targetFont = fontList.find((f) => f.fontFamily === font.fontFamily);
            if (targetFont) targetFont.text += font.text;
            else fontList.push(font);
            return fontList;
        }, [])
        .filter((f) => f.text);
    return resultFontList;
};

export const createFontBehaviors = (frameworkIdentity: string) => {
    const behaviors: Behaviors = {
        getTextInfo: (layer) => collectChartLayerFonts(layer.data as IChartLayerProps),
    };

    return behaviors;
};
